// import { useLocationStore } from '@ahm/react-map/store';
// import { intercityStore } from './use-intercity-booking-store';

// useLocationStore.subscribe((state) => {
//   const setRequest = intercityStore.getState().setRequest;
//   const selectedService = intercityStore.getState().selectedService;
//   if (
//     state.paths &&
//     state.paths.length > 1 &&
//     state.paths[state.paths.length - 1].item_value &&
//     selectedService?.requests?.find(
//       (req) => req._id === 'SGN-INTERCT-STANDARD-INSURANCE'
//     )
//   ) {
//     const requestIds = selectedService.requests
//       .filter((req) => req._id === 'SGN-INTERCT-STANDARD-INSURANCE')
//       .map((req) => {
//         return { _id: req._id };
//       });
//     setRequest(requestIds as [{ _id: string }]);
//   } else {
//     setRequest(null);
//   }
// });

// export * from './use-intercity-booking-store';
export * from './use-subscriptions-store';
